export default "__VITE_ASSET__pAUUdPYF__"